import React, { useState } from "react"
import { graphql } from "gatsby"
import { Typography } from "antd"
import Layout from "../../components/Layout"
import "../../styles/services.scss"
import News from "../../components/News"
import OdooTopSection from "../../components/OdooTopSection"
import ServiceCard from "../../components/ServiceCard"
import Wethoughtyoumighthavequestions from "../../components/Wethoughtyoumighthavequestions"
import InfoModal from "../../components/InfoModal"
import SimplifiedSteps from "../../components/SimplifiedSteps"
import Simplified_div from "../../components/Simplified_div"
import sc_performance from "../../images/servicecard/performance.png"
import sc_testing     from "../../images/servicecard/Automated testing.png"
import sc_integration from "../../images/servicecard/integration.png"
import sc_cloud       from "../../images/servicecard/cloud.png"
import sc_deployment  from "../../images/servicecard/deployment.png"
import sc_legacy      from "../../images/servicecard/legacy.png"
import d365Img1 from "../../images/D365/walkerssk-advisor-9652579_1920.jpg"
import d365Img2 from "../../images/D365/aymanejed-laptop-3196481_1920.jpg"
import d365Img3 from "../../images/D365/stocksnap-people-2569234_1920.jpg"
import d365Img4 from "../../images/D365/bertholdbrodersen-consulting-3031678_1920.jpg"
import d365Img5 from "../../images/D365/ayaanaabhi-work-8049516_1920.jpg"

const { Title } = Typography

const benefitSlides = [
  {
    img: d365Img1,
    heading: "A Consultant Who Knows Your System",
    text: "Stop re-explaining your environment with every support ticket. Your assigned D365 consultant learns your system, your processes, and your team — delivering guidance that compounds in value the longer we work together.",
  },
  {
    img: d365Img2,
    heading: "Performance That Keeps Pace With Growth",
    text: "A D365 environment that ran well at go-live may need tuning 18 months later. We stay ahead of performance drift, applying targeted improvements before users feel the impact.",
  },
  {
    img: d365Img3,
    heading: "One Place for Every Update",
    text: "Visibility reduces friction. Our managed services integrate into the tools your team already uses — Teams, SharePoint, JIRA — so progress, incidents, and decisions are always in one place.",
  },
  {
    img: d365Img4,
    heading: "SLAs You Can Hold Us To",
    text: "SLAs are only as good as the team behind them. We define severity levels and response commitments upfront, track them transparently, and review performance with you every month — no ambiguity, no excuses.",
  },
  {
    img: d365Img5,
    heading: "Improvement Built Into Every Cycle",
    text: "Managed services shouldn't stand still. Each review cycle surfaces improvement opportunities — in system health, process efficiency, or feature adoption — and translates them into a concrete action plan for the next period.",
  },
]

const Dynamics365FinanceOperations = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const [isModalVisible, setIsModalVisible] = useState(false)

  return (
    <div className="dynamics-parent-class">
      <div className="dynamics365FinanceOperations">
        <Layout
          pageTitle={"Dynamics 365 Managed Services | D365 Support & Optimisation | Visiomate"}
          descrip={
            "Visiomate delivers expert Microsoft Dynamics 365 managed services — proactive monitoring, SLA-backed support, patch management, and continuous F&O optimisation. Keep your D365 environment healthy and your business moving."
          }
        >
          <OdooTopSection
            headerData={{
              title: "Keep Your Dynamics 365 Running at Its Best — 24/7 Managed Services",
              para: "From incident response to continuous improvement, Visiomate's Dynamics 365 Managed Services give you expert coverage, defined SLAs, and a dedicated team — so your business-critical ERP never slows you down.",
            }}
            data={data}
          />
          <div className="services-page-container position-relative">
            <div className="services-description-section">
              <div className="service-heading-and-detail">
                <Title>Why Businesses Choose Visiomate for D365 Managed Services</Title>
              </div>
              <div className="service-cards-wrapper">
                <ServiceCard
                  img_src={sc_performance}
                  img_alt="D365 dedicated consultants"
                  card_heading="Dedicated D365 Consultants"
                  card_para="Get a named D365 expert who knows your environment, not a rotating helpdesk. Our certified consultants provide hands-on guidance, configuration support, and strategic advice aligned to your business goals at every stage."
                />
                <ServiceCard
                  img_src={sc_testing}
                  img_alt="D365 continuous optimisation"
                  card_heading="Continuous System Optimisation"
                  card_para="Your D365 environment evolves as your business grows. We proactively identify performance bottlenecks, recommend configuration improvements, and use your consultancy hours to keep the system lean and efficient."
                />
                <ServiceCard
                  img_src={sc_integration}
                  img_alt="D365 collaboration tools"
                  card_heading="Full Visibility Across Every Team"
                  card_para="Stay in control with real-time dashboards and integrations into Microsoft Teams, SharePoint, and JIRA. Every stakeholder gets full visibility into system health, incidents, and progress — no chasing required."
                />
                <ServiceCard
                  img_src={sc_cloud}
                  img_alt="D365 SLA adherence"
                  card_heading="SLA-Backed Accountability"
                  card_para="Downtime has a cost. Our SLAs define exactly what to expect — response times, severity tiers, escalation paths, and resolution targets — with monthly reviews to keep service quality on track."
                />
                <ServiceCard
                  img_src={sc_deployment}
                  img_alt="D365 continuous feedback"
                  card_heading="Structured Reviews, Real Improvements"
                  card_para="Every service review is a chance to do better. We track issue trends, system health metrics, and strategic alignment — then turn those insights into concrete actions that strengthen your D365 environment month on month."
                />
                <ServiceCard
                  card_heading="Ready to take the burden off your internal team?"
                  card_button="Book a Free Consultation"
                />
              </div>
            </div>
          </div>
          <div className="d365-feature-strip">
            <span>Domain Expertise</span>
            <span>24/7 Support</span>
            <span>SLA Adherence</span>
            <span>Proactive Monitoring</span>
            <span>Change Management</span>
            <span>Operational Audits</span>
            <span>Vulnerability Scans</span>
            <span>Governance Structure</span>
          </div>
          <div className="d365-benefits-section">
            <div className="d365-benefits-intro">
              <Title>
                What You Gain With <strong>Dynamics 365 Managed Services</strong> From Visiomate
              </Title>
              <p>
                Our Microsoft Dynamics 365 Managed Services are built around one goal: keeping your ERP healthy, your team productive, and your operations uninterrupted — so the platform works for your business, not the other way around.
              </p>
            </div>
            <div className="d365-carousel-wrapper">
              <button
                className="d365-arrow d365-arrow-prev"
                onClick={() => setCurrentSlide((currentSlide - 1 + benefitSlides.length) % benefitSlides.length)}
                aria-label="Previous slide"
              >
                &#8592;
              </button>
              <div className="d365-slide">
                <div className="d365-slide-text">
                  <h3>{benefitSlides[currentSlide].heading}</h3>
                  <p>{benefitSlides[currentSlide].text}</p>
                </div>
                <div
                  className="d365-slide-img"
                  style={{ backgroundImage: `url(${benefitSlides[currentSlide].img})` }}
                />
              </div>
              <button
                className="d365-arrow d365-arrow-next"
                onClick={() => setCurrentSlide((currentSlide + 1) % benefitSlides.length)}
                aria-label="Next slide"
              >
                &#8594;
              </button>
            </div>
            <div className="d365-carousel-dots">
              {benefitSlides.map((_, i) => (
                <button
                  key={i}
                  className={`d365-dot${i === currentSlide ? " active" : ""}`}
                  onClick={() => setCurrentSlide(i)}
                  aria-label={`Slide ${i + 1}`}
                />
              ))}
            </div>
          </div>
          {/* <SimplifiedSteps>
            <Simplified_div headingNo={"01"} heading="Environment Assessment" showButton={true}
            >
              <li>Audit your D365 F&O environment — performance baselines, patch levels, batch job health, and customisation inventory — so managed services begin from a fully documented state.</li>
              <li>Flag integration risks, configuration gaps, and known issues before go-live on the engagement.</li>
              <li>Establish measurable benchmarks so every future improvement can be tracked against a baseline.</li>
            </Simplified_div>
            <Simplified_div headingNo={"02"} heading="Support Model Design">
              <li>Define SLAs, severity classifications, response times, and escalation paths tailored to your operational hours and risk tolerance.</li>
              <li>Configure ticketing workflows, communication channels, and on-call protocols so every incident is handled consistently from day one.</li>
            </Simplified_div>
            <Simplified_div headingNo={"03"} heading="Integration Landscape Mapping">
              <li>Catalogue every system connected to D365 — ERP, CRM, e-commerce, logistics, HR, and internal tools — with documented data flows, sync frequency, and ownership.</li>
              <li>Identify integration dependencies and failure points that could affect incident resolution or update deployments.</li>
            </Simplified_div>
            <Simplified_div headingNo={"04"} heading="Integration Build and Validation">
              <li>Develop or stabilise integrations using REST APIs, Azure Logic Apps, or the D365 Data Management Framework — built to your exact specifications and change-tolerant by design.</li>
              <li>Validate all integration flows in a dedicated sandbox before any change reaches production.</li>
            </Simplified_div>
            <Simplified_div headingNo={"05"} heading="Targeted Customisation">
              <li>Extend D365 with scoped X++ customisations and workflow adjustments built precisely to your requirements — no over-engineering, no unnecessary complexity.</li>
              <li>All customisations are documented, version-controlled, and designed to survive future Microsoft release waves.</li>
            </Simplified_div>
            <Simplified_div headingNo={"06"} heading="Non-Production Validation">
              <li>Every change — configuration update, customisation, patch, or integration fix — is deployed to a test environment and validated against real business scenarios before production.</li>
              <li>User acceptance testing is coordinated with your team so nothing ships without sign-off.</li>
            </Simplified_div>
            <Simplified_div headingNo={"07"} heading="Controlled Production Deployment">
              <li>Releases follow a documented deployment plan with a tested rollback procedure confirmed ready before go-live.</li>
              <li>System performance is monitored in real time immediately after deployment to catch unexpected behaviour before users are affected.</li>
            </Simplified_div>
            <Simplified_div headingNo={"08"} heading="User Enablement and Training">
              <li>Role-specific training for finance, operations, and admin users ensures new features and workflow changes are adopted — not worked around.</li>
              <li>Training is delivered at the point of change so knowledge is retained, embedded into daily work, and measurable in adoption metrics.</li>
            </Simplified_div>
            <Simplified_div headingNo={"09"} heading="Continuous Monitoring and Improvement">
              <li>We monitor your D365 environment continuously — patch status, batch job health, integration uptime, and performance indicators — resolving issues before they escalate into incidents.</li>
              <li>Regular service reviews align the managed services engagement with your evolving business strategy, turning operational data into a forward improvement roadmap.</li>
            </Simplified_div>
          </SimplifiedSteps> */}
          <Wethoughtyoumighthavequestions
            data={[
              {
                question: "What are Dynamics 365 managed services?",
                answer:
                  "Dynamics 365 managed services is a structured, ongoing partnership where Visiomate takes responsibility for the health, performance, and continuous improvement of your D365 environment. Rather than waiting for issues to be reported, we monitor proactively, resolve incidents, manage updates, and continuously optimise — freeing your team to focus on business outcomes rather than platform upkeep.",
                answer1: "",
                answer2: "",
                answer3: "",
                answer4: "",
                answer5: "",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "How is this different from Microsoft's own support or a standard IT helpdesk?",
                answer:
                  "Microsoft's support handles licensing, product bugs, and platform-level issues — it does not cover your specific environment, customisations, integrations, or business processes. A standard IT helpdesk reacts to tickets. Visiomate's managed services are different on both counts:",
                answer1:
                  "- We know your specific D365 configuration, not just the product in general.",
                answer2:
                  "- We are proactive: we find and resolve issues before your users report them.",
                answer3:
                  "- We cover customisations, integrations, workflows, and business-process changes — not just the base platform.",
                answer4:
                  "- You get dedicated consultancy hours for improvements, not just break-fix responses.",
                answer5:
                  "- We act as a specialist extension of your team, not a third-party ticket queue.",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "What is included in the managed services scope — and what is not?",
                answer:
                  "Included in every engagement:",
                answer1:
                  "- Proactive monitoring: system performance, batch jobs, integration uptime, and patch status.",
                answer2:
                  "- Incident management: triage, root cause analysis, resolution, and prevention planning.",
                answer3:
                  "- Patch and update management: impact assessment, regression testing, and controlled deployment.",
                answer4:
                  "- Dedicated consultancy hours: configuration changes, enhancements, and workflow adjustments.",
                answer5:
                  "- Integration support: monitoring and maintenance of third-party system connections.",
                answer6:
                  "- Monthly governance reviews and transparent service quality reporting.",
                answer7:
                  "Not included by default: new module implementations, major re-implementations, or large net-new development projects. These are scoped and priced separately.",
                answer8: "",
                answer9: "",
              },
              {
                question: "What are your response times, and is support available 24/7?",
                answer:
                  "Response times are defined by severity tier and agreed in your SLA during onboarding. Typical commitments are:",
                answer1:
                  "- Critical (system down, business halted): response within 1 hour, available 24/7.",
                answer2:
                  "- High (major function impaired): response within 4 business hours.",
                answer3:
                  "- Medium (partial impact, workaround available): response within 1 business day.",
                answer4:
                  "- Low (minor issue or enhancement request): response within 2–3 business days.",
                answer5:
                  "24/7 coverage applies to critical and high-severity incidents. Extended coverage for lower severity tiers can be agreed if your operations require it.",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "Can you manage a D365 environment that was implemented by a different partner?",
                answer:
                  "Yes. We take on environments built by any partner or in-house team. Our onboarding process begins with a full environment assessment — reviewing customisations, configurations, integrations, code quality, and outstanding issues — so we fully understand the system before any managed services work begins. There is no requirement for Visiomate to have delivered the original implementation.",
                answer1: "",
                answer2: "",
                answer3: "",
                answer4: "",
                answer5: "",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "How do you protect our customisations when Microsoft releases updates?",
                answer:
                  "Every Microsoft update — whether a major release wave or a routine patch — is assessed against your specific environment before it is applied:",
                answer1:
                  "- Impact assessment: we review how the update affects your customisations, integrations, and active workflows.",
                answer2:
                  "- Sandbox testing: all changes are deployed to a non-production environment and regression-tested first.",
                answer3:
                  "- Sign-off: your team validates behaviour in the test environment before production deployment.",
                answer4:
                  "- Controlled release: production deployment follows a documented plan with a confirmed rollback procedure.",
                answer5:
                  "- Post-deployment monitoring: we watch system performance in real time after every release to catch unexpected behaviour early.",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "What if we already have an internal IT team?",
                answer:
                  "Managed services are designed to complement your internal team, not replace it. Most organisations using managed services have internal IT staff — the difference is that D365 requires deep, specialist knowledge that a generalist team cannot always sustain alongside other priorities.",
                answer1:
                  "- Your internal team retains control over business decisions, user management, and day-to-day operations.",
                answer2:
                  "- We handle D365-specific expertise: platform monitoring, update management, integrations, and X++ customisations.",
                answer3:
                  "- We work within your existing ticketing and communication tools so the engagement is seamless, not disruptive.",
                answer4:
                  "- Escalation paths are agreed upfront so your team always knows when and how to involve us.",
                answer5: "",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "What does onboarding look like, and how quickly can we get started?",
                answer:
                  "Onboarding typically takes two to four weeks depending on environment complexity. The process covers:",
                answer1:
                  "- Environment assessment: full audit of your D365 instance, customisations, integrations, and known issues.",
                answer2:
                  "- SLA and support model agreement: response times, severity classifications, escalation paths, and communication channels.",
                answer3:
                  "- Tooling setup: access provisioning, monitoring configuration, and integration with your ticketing or collaboration tools.",
                answer4:
                  "- Baseline documentation: a complete record of your environment at engagement start, used to measure every future change.",
                answer5:
                  "No existing managed services partner or Microsoft CSP relationship is required to begin.",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "How do we know the managed services are actually delivering value?",
                answer:
                  "Transparency is built into the engagement from day one. Each month you receive:",
                answer1:
                  "- A service report covering all incidents raised, resolved, time to resolution, and SLA performance against targets.",
                answer2:
                  "- A service review meeting where we walk through system health, improvements made, and upcoming priorities.",
                answer3:
                  "- A clear log of consultancy hours used and the outcomes delivered in that period.",
                answer4:
                  "- Forward-looking recommendations: what we plan to address next and why.",
                answer5:
                  "If SLA targets are missed, corrective actions are agreed in writing at the next review. You always have a documented record of what was promised and what was delivered.",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
              {
                question: "Is there a minimum contract length, and can we scale the service up or down?",
                answer:
                  "Engagements are typically structured on an initial 12-month term to allow the managed services model to deliver its full value — particularly the proactive improvements and environment knowledge that accumulate over time. After the initial term, the engagement continues on a rolling basis.",
                answer1:
                  "- Consultancy hours can be adjusted up or down at the start of each contract period based on your planned activity.",
                answer2:
                  "- Additional modules, environments, or integrations can be added to scope at any time.",
                answer3:
                  "- If your needs change significantly mid-term, we work with you to adjust the engagement rather than holding you to a scope that no longer fits.",
                answer4: "",
                answer5: "",
                answer6: "",
                answer7: "",
                answer8: "",
                answer9: "",
              },
            ]}
            title="Frequently Asked Questions"
          />
          <div className="faq-dark-banner">
            <h2>Ready to Simplify Your Dynamics 365 Support?</h2>
            <p className="faq-banner-subtitle">
              Take the burden off your internal team. Our D365 Managed Services deliver proactive monitoring, SLA-backed incident response, and continuous optimisation — so your ERP stays healthy and your business keeps moving.
            </p>
            <button className="faq-banner-cta" onClick={() => setIsModalVisible(true)}>
              Connect with us <span>&#8594;</span>
            </button>
          </div>
          <InfoModal
            companyIsEnabled
            url="http://185.213.27.237:8066/Email/ContactUs"
            isModalVisible={isModalVisible}
            handleOk={() => setIsModalVisible(false)}
            handleCancel={() => setIsModalVisible(false)}
          />
          <News isAbout={true} career={true} />
        </Layout>
      </div>
    </div>
  )
}

export default Dynamics365FinanceOperations

export const query = graphql`
  query Dynamics365FinanceOperationsImages {
    VMLogoBlack: file(relativePath: { eq: "logo_black_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    VMLogoWhite: file(relativePath: { eq: "logo_white_LST.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    Odooimg: file(relativePath: { eq: "Maskgroupcopy.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    markFlag: file(
      relativePath: { eq: "4879902_check_flag_mark_ok_icon_1_copy.png" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    RSSImages1: file(
      relativePath: { eq: "DemoImages/jaredd-craig-HH4WBGNyltc-unsplash.jpg" }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    RSSImages2: file(
      relativePath: {
        eq: "DemoImages/kourosh-qaffari-RrhhzitYizg-unsplash.jpg"
      }
    ) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
